export const FETCH_DATA = "FETCH_DATA";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const ADD_NEW_SUCCESS = "ADD_NEW_SUCCESS";
export const ADD_NEW_FAIL = "ADD_NEW_FAIL";
export const FETCH_DATA_FALSE = "FETCH_DATA_FALSE";
export const FETCH_DATA_DETAIL = "FETCH_DATA_DETAIL";
export const FETCH_DATA_DETAIL_ERROR = "FETCH_DATA_DETAIL_ERROR";
export const FETCH_DATA_DETAI_SUCCESS = "FETCH_DATA_DETAI_SUCCESS";
